import styled from 'styled-components';

const GroupsStyle = styled.div`
  & .rst__row {
    > div {
      transition: all 0.2s ease-in-out 0s;
      background: #f0f0f0;
      border: #f0f0f0;
      box-shadow: none;
      padding-left: 0;

      &:first-child {
        border-radius: 8px 0 0 8px;
      }

      &:last-child {
        font-family: 'Avenir', sans-serif;
        border-radius: 0 8px 8px 0;
        text-transform: capitalize;
        font-weight: bold;
        line-height: 45px;
        line-height: 45px;
        font-size: 1.2rem;
        color: white;
      }
    }

    & .rst__moveHandle,
    & .rst__loadingHandle {
      height: 100%;
      width: 44px;
      background: #f0f0f0 url('/assets/icons/move-wrapper.svg') no-repeat center;
      border: solid #f0f0f0 1px;
      box-shadow: none;
      cursor: move;
      z-index: 1;
    }
  }

  & .rst__node {
    .rst__rowTitle {
      font-weight: 800;
      font-size: 14px;
      line-height: 10px;
      color: #000000;
    }

    .rst__row {
      min-width: 440px;
      height: 48px;
    }

    .rst__lineHalfHorizontalRight::before {
      height: 1px;
      width: 50%;
    }

    .rst__lineChildren::after,
    .rst__lineHalfHorizontalRight::after,
    .rst__lineFullVertical::after {
      background-color: #ababab;
      width: 1px;
    }

    .rst__collapseButton,
    .rst__expandButton {
      box-shadow: 0 0 0 1px #ababab;
    }

    .rst__lineHalfHorizontalRight,
    .rst__lineFullVertical,
    .rst__lineHalfVerticalTop,
    .rst__lineHalfVerticalBottom {
      &:after,
      &:before {
        position: absolute;
        content: '';
        background-color: #ababab;
      }

      & button {
        background: red;

        &.rst__nodeContent {
          box-shadow: 0px 0px 0 1px #00EB84;
        }
      }
    }
  }
`;

export const TitleWrapper = styled.div`
  width: 100%;
  margin-bottom: 30px;

  h1 {
    margin-bottom: 7px;
  }
`;

export const ButtonWrapper = styled.div`
  margin: 10px 0 20px 0;

  button {
    min-width: auto;
  }
`;

export default GroupsStyle;
export { GroupsStyle };
